import React from 'react';

import css from './SectionStudentInfo.module.css';
import HeaderBar from '../HeaderBar/HeaderBar';
import MicIcon from './images/mic-icon.svg';
import { getCreditsAmont } from '../../../../util/userUtil';

const SectionStudentInfo = props => {
  const { currentUser, currentUserProfileListing } = props;

  const userCredits = getCreditsAmont(currentUser);
  // const nextMoreCreditsDays = 12;
  // const totalHoursSpent = 3;
  // const totalHoursSpentPercengate = 15;

  return (
    <div className={css.root}>
      <HeaderBar currentUser={currentUser} currentUserProfileListing={currentUserProfileListing} />

      <div className="row gap20 mt20">
        <div className="card gap20">
          <div className="row  gap20">
            <div className={css.cardMicIconWrapper}>
              <img src={MicIcon} />
            </div>

            <div className="col">
              <span className={css.value}>{userCredits}</span>

              <span className={css.label}>Credits left</span>
            </div>
          </div>

          {/* <span className={css.info}>
                        <FormattedMessage id="SectionStudentInfo.nextCreditsDays" values={{ days: nextMoreCreditsDays }} />
                    </span> */}
        </div>

        {/* <div className='card gap20'>

                    <div className='row  gap20'>
                        <div className={css.cardClockIconWrapper}>
                            <img src={ClockIcon} />
                        </div>

                        <div className='col'>
                            <span className={css.value}>
                                {totalHoursSpent}

                                <FormattedMessage id={totalHoursSpent === 1 ? "SectionStudentInfo.hour" : "SectionStudentInfo.hours"} />
                            </span>

                            <span className={css.label}>
                                <FormattedMessage id="SectionStudentInfo.timeSpent" />
                            </span>
                        </div>
                    </div>

                    <span className={css.info}>
                        <FormattedMessage id="SectionStudentInfo.moreThanAverage" values={{
                            percent:
                                <span className={css.percent}>
                                    {totalHoursSpentPercengate}{'%'}
                                </span>
                        }} />
                    </span>

                </div> */}
      </div>
    </div>
  );
};

export default SectionStudentInfo;
